"use strict";

require("core-js/modules/es.object.to-string.js");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
var _reverseInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/reverse");
var _Promise = require("@babel/runtime-corejs3/core-js-stable/promise");
var _Object$setPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/set-prototype-of");
var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of");
var _Object$create = require("@babel/runtime-corejs3/core-js-stable/object/create");
var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePreview = void 0;
exports.openPreview = openPreview;
exports.registerFilePreview = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.number.constructor.js");
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));
var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _element = require("@onviobr/element");
var _pdfRenderer = require("@onviobr/pdf-renderer/pdf-renderer");
var _outline = require("@onviobr/pdf-renderer/utils/outline");
var _i18n = require("../i18n/i18n");
var _emitEvents = require("../utils/emit-events");
var _styles = require("./styles");
var _header = require("./header");
var _previewData = require("./preview-data");
var _actions = require("./actions");
var _document = require("./services/document");
var _outline2 = require("./outline");
var _htmlWhitelist = _interopRequireDefault(require("./html-whitelist"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = _Object$defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof _Symbol ? _Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return _Object$defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = _Object$create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = _Object$getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(IteratorPrototype); function defineIteratorMethods(prototype) { var _context30; _forEachInstanceProperty2(_context30 = ["next", "throw", "return"]).call(_context30, function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], _forEachInstanceProperty2(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return _Object$setPrototypeOf ? _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = _Object$create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = _Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return _reverseInstanceProperty(keys).call(keys), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { var _context31; if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, _forEachInstanceProperty2(_context31 = this.tryEntries).call(_context31, resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+_sliceInstanceProperty(name).call(name, 1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var FilePreview = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(FilePreview, _BlueElement);
  var _super = (0, _createSuper2.default)(FilePreview);
  function FilePreview() {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15;
    var _this;
    (0, _classCallCheck2.default)(this, FilePreview);
    _this = _super.call(this);
    _this.actionInProgress = '';
    _this.actionLoading = false;
    _this.bookmark = undefined;
    _this.currentIndex = 0;
    _this.currentPage = 1;
    _this.customHeaderButtons = undefined;
    _this.documentItem = null;
    _this.documents = [];
    _this.documentVerId = null;
    _this.documentName = '';
    _this.documentType = '';
    _this.downloadUri = undefined;
    _this.emitHeaderButtonClicks = false;
    _this.helpItems = undefined;
    _this.hideDocumentName = false;
    _this.hideBookmarks = false;
    _this.hideClose = false;
    _this.hideDelete = true;
    _this.hideDownload = false;
    _this.hideHelp = true;
    _this.hidePrint = false;
    _this.iframeSrc = '';
    _this.initialZoom = 1;
    _this.invalidPassword = false;
    _this.jumpScroll = false;
    _this.loading = true;
    _this.outline = undefined;
    _this.password = '';
    _this.pdfLoading = false;
    _this.previewItems = [];
    _this.rotate = 0;
    _this.showOutline = false;
    _this.showPassword = false;
    _this.renderingError = false;
    _this.themeColor = undefined;
    _this.token = '';
    _this.totalPages = 1;
    _this.usePDF = false;
    _this.zoom = 1;
    _this.setCurrentPage = (0, _bind.default)(_context = _this.setCurrentPage).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.prevDoc = (0, _bind.default)(_context2 = _this.prevDoc).call(_context2, (0, _assertThisInitialized2.default)(_this));
    _this.nextDoc = (0, _bind.default)(_context3 = _this.nextDoc).call(_context3, (0, _assertThisInitialized2.default)(_this));
    _this.prevPage = (0, _bind.default)(_context4 = _this.prevPage).call(_context4, (0, _assertThisInitialized2.default)(_this));
    _this.nextPage = (0, _bind.default)(_context5 = _this.nextPage).call(_context5, (0, _assertThisInitialized2.default)(_this));
    _this.zoomIn = (0, _bind.default)(_context6 = _this.zoomIn).call(_context6, (0, _assertThisInitialized2.default)(_this));
    _this.zoomOut = (0, _bind.default)(_context7 = _this.zoomOut).call(_context7, (0, _assertThisInitialized2.default)(_this));
    _this.handlePreviewContainerPositioning = (0, _bind.default)(_context8 = _this.handlePreviewContainerPositioning).call(_context8, (0, _assertThisInitialized2.default)(_this));
    _this.handlePdfLoadComplete = (0, _bind.default)(_context9 = _this.handlePdfLoadComplete).call(_context9, (0, _assertThisInitialized2.default)(_this));
    _this.getOutline = (0, _bind.default)(_context10 = _this.getOutline).call(_context10, (0, _assertThisInitialized2.default)(_this));
    _this.navigateToBookmark = (0, _bind.default)(_context11 = _this.navigateToBookmark).call(_context11, (0, _assertThisInitialized2.default)(_this));
    _this.closeOutline = (0, _bind.default)(_context12 = _this.closeOutline).call(_context12, (0, _assertThisInitialized2.default)(_this));
    _this.handlePassword = (0, _bind.default)(_context13 = _this.handlePassword).call(_context13, (0, _assertThisInitialized2.default)(_this));
    _this.handlePasswordKey = (0, _bind.default)(_context14 = _this.handlePasswordKey).call(_context14, (0, _assertThisInitialized2.default)(_this));
    _this.handlePdfRendererError = (0, _bind.default)(_context15 = _this.handlePdfRendererError).call(_context15, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(FilePreview, [{
    key: "setPages",
    value: function setPages() {
      var parser = new DOMParser();
      var html = parser.parseFromString(this.documentItem, 'text/html');
      var mimeToSearch = this.previewItems[this.currentIndex].mimeType;
      var pages = html.querySelectorAll(_htmlWhitelist.default.supportedTypesFindQuerySelector(mimeToSearch));
      this.totalPages = Boolean(pages) && pages.length > 0 ? pages.length : 1;
    }
  }, {
    key: "checkIsVisible",
    value: function checkIsVisible(page) {
      var rect = page.getBoundingClientRect();
      var top = rect.top,
        bottom = rect.bottom;
      var isVisible = top >= 0 && top <= window.innerHeight * 0.5 - 50 && bottom >= window.innerHeight * 0.5 - 50 || top <= window.innerHeight * 0.5 - 50 && bottom >= window.innerHeight * 0.5 - 50 || top >= 0;
      return isVisible;
    }
  }, {
    key: "setCurrentPage",
    value: function setCurrentPage() {
      var _this$shadowRoot,
        _this2 = this;
      var mimeToSearch = this.previewItems[this.currentIndex].mimeType;
      var pages = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelectorAll(_htmlWhitelist.default.supportedTypesFindQuerySelector(mimeToSearch));
      if (pages && (pages === null || pages === void 0 ? void 0 : pages.length) > 0) {
        var _context16, _context17;
        var visiblePage = (0, _find.default)(_context16 = (0, _toConsumableArray2.default)(pages)).call(_context16, function (page) {
          return _this2.checkIsVisible(page);
        });
        this.currentPage = visiblePage ? (0, _indexOf.default)(_context17 = (0, _toConsumableArray2.default)(pages)).call(_context17, visiblePage) + 1 : this.currentPage;
        this.jumpScroll = false;
        this.requestUpdateVoid();
      }
    }
  }, {
    key: "requestUpdateVoid",
    value: function requestUpdateVoid() {
      void this.requestUpdate();
    }
  }, {
    key: "handlePreviewContainerPositioning",
    value: function handlePreviewContainerPositioning() {
      var _this$shadowRoot2;
      var previewContainer = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.querySelector('#htmlPreviewContainer');
      if (!previewContainer) {
        return;
      }
      var _previewContainer$get = previewContainer.getBoundingClientRect(),
        left = _previewContainer$get.left,
        right = _previewContainer$get.right;
      if (left < 1 && right > window.innerWidth) {
        previewContainer.style.setProperty('--transform', '0 0');
        previewContainer.style.setProperty('--left', "0");
      } else {
        previewContainer.style.setProperty('--transform', 'top');
        previewContainer.style.setProperty('--left', 'auto');
      }
    }
  }, {
    key: "setInitialZoom",
    value: function setInitialZoom() {
      var _this3 = this;
      if (this.initialZoom) {
        var _this$shadowRoot3;
        this.zoom = this.initialZoom;
        ((_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : _this$shadowRoot3.host).style.setProperty('--zoom', this.zoom);
        this.handlePreviewContainerPositioning();
        this.requestUpdateVoid();
      } else {
        (0, _setTimeout2.default)(function () {
          var _this3$shadowRoot, _this3$shadowRoot2;
          var mimeToSearch = _this3.previewItems[_this3.currentIndex].mimeType;
          var pages = (_this3$shadowRoot = _this3.shadowRoot) === null || _this3$shadowRoot === void 0 ? void 0 : _this3$shadowRoot.querySelectorAll(_htmlWhitelist.default.supportedTypesFindQuerySelector(mimeToSearch));
          var ratio = 1;
          if (pages && pages.length > 0) {
            var pageDim = pages[0].getBoundingClientRect();
            var height = pageDim.height;
            var width = pageDim.width;
            var heightRatio = (window.innerHeight - 50) / height;
            var widthRatio = window.innerWidth / width;
            ratio = width > height ? widthRatio : heightRatio;
          }
          _this3.zoom = ratio < 1 ? Math.round(ratio * 10) / 10 : 1;
          ((_this3$shadowRoot2 = _this3.shadowRoot) === null || _this3$shadowRoot2 === void 0 ? void 0 : _this3$shadowRoot2.host).style.setProperty('--zoom', _this3.zoom);
          _this3.handlePreviewContainerPositioning();
          _this3.requestUpdateVoid();
        }, 100);
      }
    }
  }, {
    key: "setTheme",
    value: function setTheme() {
      var _this4 = this;
      var count = 0;
      (0, _setTimeout2.default)(function () {
        if (_this4.themeColor && count < 25) {
          var _this4$shadowRoot;
          var hostEl = (_this4$shadowRoot = _this4.shadowRoot) === null || _this4$shadowRoot === void 0 ? void 0 : _this4$shadowRoot.host;
          hostEl === null || hostEl === void 0 ? void 0 : hostEl.setAttribute('style', "--theme-color: ".concat(_this4.themeColor));
        } else {
          count++;
          _this4.setTheme();
        }
      }, 50);
    }
  }, {
    key: "removeTooltipStyle",
    value: function removeTooltipStyle() {
      var styleTag = document.querySelector('#bmPreviewTooltipStyle');
      if (styleTag) {
        var _styleTag$parentEleme;
        (_styleTag$parentEleme = styleTag.parentElement) === null || _styleTag$parentEleme === void 0 ? void 0 : _styleTag$parentEleme.removeChild(styleTag);
      }
    }
  }, {
    key: "setTooltipStyle",
    value: function setTooltipStyle() {
      var style = document.createElement('STYLE');
      style.setAttribute('id', 'bmPreviewTooltipStyle');
      style.innerHTML = '.tooltip {background-color: #fff;}';
      var append = document.querySelectorAll('BODY')[0].append || document.querySelectorAll('BODY')[0].appendChild;
      append.call(document.querySelectorAll('BODY')[0], style);
    }
  }, {
    key: "setTooltips",
    value: function setTooltips() {
      this.setTooltipStyle();
      try {
        var _this$shadowRoot4;
        var els = (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.querySelectorAll("[data-toggle='tooltip-left']");
        els === null || els === void 0 ? void 0 : (0, _forEach.default)(els).call(els, function (el) {
          new Tooltip(el, {
            placement: 'left',
            delay: 1,
            container: document.querySelectorAll('BODY')[0]
          });
        });
      } catch (_) {}
      try {
        var _this$shadowRoot5;
        var _els = (_this$shadowRoot5 = this.shadowRoot) === null || _this$shadowRoot5 === void 0 ? void 0 : _this$shadowRoot5.querySelectorAll("[data-toggle='tooltip-right']");
        _els === null || _els === void 0 ? void 0 : (0, _forEach.default)(_els).call(_els, function (el) {
          new Tooltip(el, {
            placement: 'right',
            delay: 1,
            container: document.querySelectorAll('BODY')[0]
          });
        });
      } catch (_) {}
      try {
        var _this$shadowRoot6;
        var _els2 = (_this$shadowRoot6 = this.shadowRoot) === null || _this$shadowRoot6 === void 0 ? void 0 : _this$shadowRoot6.querySelectorAll("[data-toggle='tooltip-bottom']");
        _els2 === null || _els2 === void 0 ? void 0 : (0, _forEach.default)(_els2).call(_els2, function (el) {
          new Tooltip(el, {
            placement: 'bottom',
            delay: 1,
            container: document.querySelectorAll('BODY')[0]
          });
        });
      } catch (_) {}
      try {
        var _this$shadowRoot7;
        var _els3 = (_this$shadowRoot7 = this.shadowRoot) === null || _this$shadowRoot7 === void 0 ? void 0 : _this$shadowRoot7.querySelectorAll("[data-toggle='tooltip-top']");
        _els3 === null || _els3 === void 0 ? void 0 : (0, _forEach.default)(_els3).call(_els3, function (el) {
          new Tooltip(el, {
            placement: 'top',
            delay: 1,
            container: document.querySelectorAll('BODY')[0]
          });
        });
      } catch (_) {}
    }
  }, {
    key: "clearTooltips",
    value: function clearTooltips() {
      this.removeTooltipStyle();
      (0, _setTimeout2.default)(function () {
        var els = document.querySelectorAll(".tooltip");
        (0, _forEach.default)(els).call(els, function (el) {
          var _el$parentElement;
          (_el$parentElement = el.parentElement) === null || _el$parentElement === void 0 ? void 0 : _el$parentElement.removeChild(el);
        });
      }, 250);
    }
  }, {
    key: "hideTooltips",
    value: function hideTooltips() {
      var els = document.querySelectorAll('.tooltip');
      (0, _forEach.default)(els).call(els, function (el) {
        el.style.visibility = 'hidden';
      });
    }
  }, {
    key: "setRotate",
    value: function setRotate() {
      var _this$shadowRoot8;
      ((_this$shadowRoot8 = this.shadowRoot) === null || _this$shadowRoot8 === void 0 ? void 0 : _this$shadowRoot8.host).style.setProperty('--rotate', "".concat(this.rotate, "deg"));
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$shadowRoot9;
        return _regeneratorRuntime().wrap(function _callee$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              (0, _get2.default)((0, _getPrototypeOf2.default)(FilePreview.prototype), "connectedCallback", this).call(this);
              window.addEventListener('resize', this.handlePreviewContainerPositioning, true);
              (_this$shadowRoot9 = this.shadowRoot) === null || _this$shadowRoot9 === void 0 ? void 0 : _this$shadowRoot9.host.addEventListener('click', this.closeOutline);
              this.zoom = this.initialZoom || this.zoom;
              this.loading = true;
              this.downloadUri = this.downloadUri || '/api/storage/v1/{containerType}/{containerId}/documents/{docId}';
              this.setTheme();
              this.loading = false;
            case 8:
            case "end":
              return _context18.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(FilePreview.prototype), "disconnectedCallback", this).call(this);
      window.removeEventListener('resize', this.handlePreviewContainerPositioning, true);
      this.clearTooltips();
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      var _this5 = this,
        _this$previewItems;
      if (changedProps.has('rotate')) {
        this.setRotate();
      }
      if (changedProps.has('documents') && !this.documents || this.documents.length === 0) {
        return false;
      }
      if (changedProps.has('documents')) {
        this.loading = true;
        void (0, _previewData.setPreviewData)(this).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                _this5.pdfLoading = _this5.isPdf();
                _this5.reset();
                return _context19.abrupt("return", _this5.setDocument());
              case 3:
              case "end":
                return _context19.stop();
            }
          }, _callee2);
        }))).then(function () {
          _this5.loading = false;
        });
      }
      if (changedProps.has('currentIndex') && !((_this$previewItems = this.previewItems) !== null && _this$previewItems !== void 0 && _this$previewItems[this.currentIndex])) {
        return false;
      }
      if (changedProps.has('currentIndex') && this.previewItems && this.previewItems[this.currentIndex]) {
        this.loading = true;
        this.reset();
        void this.setDocument().then(function () {
          _this5.loading = false;
          _this5.pdfLoading = _this5.isPdf();
          _this5.requestUpdateVoid();
        });
      }
      if (this.documents && this.documents.length > 0) {
        var _context20, _context21, _context22;
        var file = (0, _find.default)(_context20 = this.documents).call(_context20, function (item) {
          return item instanceof File;
        });
        var blob = (0, _find.default)(_context21 = this.documents).call(_context21, function (item) {
          return item instanceof Blob;
        });
        var object = (0, _find.default)(_context22 = this.documents).call(_context22, function (item) {
          return item instanceof Object;
        });
        if (Boolean(blob) && Boolean(object) || Boolean(blob) && Boolean(file) || Boolean(object) && Boolean(file)) {
          (0, _emitEvents.emit)(this, 'error', {
            type: 'build',
            msg: 'Blobs, files and metadata objects cannot be combined for preview. Please pass an array of files, an array of blobs, or an object array of metadata.'
          });
          return false;
        }
        this.documentType = blob ? 'blob' : file ? 'file' : 'object';
      }
      return true;
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      this.setTooltips();
    }
  }, {
    key: "isPdf",
    value: function isPdf() {
      return this.usePDF || !(Boolean(this.previewItems) && Boolean(this.previewItems[this.currentIndex]) && _htmlWhitelist.default.supportedTypesIncludes(this.previewItems[this.currentIndex].mimeType));
    }
  }, {
    key: "handlePdfRendererError",
    value: function handlePdfRendererError(e) {
      this.loading = false;
      this.pdfLoading = false;
      if (e.detail.name === 'PasswordException') {
        this.showPassword = true;
        this.invalidPassword = e.detail.code && e.detail.code === 2;
      } else if (!e.detail.type || e.detail.type && e.detail.type !== 'cleanup') {
        this.renderingError = true;
      }
      this.requestUpdateVoid();
      return e;
    }
  }, {
    key: "handlePassword",
    value: function handlePassword() {
      var _this$shadowRoot10, _this$shadowRoot10$qu, _this$shadowRoot10$qu2;
      this.password = (_this$shadowRoot10 = this.shadowRoot) === null || _this$shadowRoot10 === void 0 ? void 0 : (_this$shadowRoot10$qu = _this$shadowRoot10.querySelector('#passwordPrompt')) === null || _this$shadowRoot10$qu === void 0 ? void 0 : (_this$shadowRoot10$qu2 = _this$shadowRoot10$qu.querySelector('input')) === null || _this$shadowRoot10$qu2 === void 0 ? void 0 : _this$shadowRoot10$qu2.value;
      this.showPassword = !this.password;
      this.invalidPassword = !this.password;
      this.pdfLoading = !this.invalidPassword && this.isPdf();
      this.requestUpdateVoid();
    }
  }, {
    key: "handlePasswordKey",
    value: function handlePasswordKey(e) {
      if (e.code === 'Enter') {
        this.handlePassword();
        return;
      }
      this.invalidPassword = false;
      this.requestUpdateVoid();
    }
  }, {
    key: "getOutline",
    value: function () {
      var _getOutline2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        return _regeneratorRuntime().wrap(function _callee3$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return (0, _outline.getOutline)(e.detail);
            case 2:
              this.outline = _context23.sent;
              this.requestUpdateVoid();
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee3, this);
      }));
      function getOutline(_x) {
        return _getOutline2.apply(this, arguments);
      }
      return getOutline;
    }()
  }, {
    key: "handlePdfLoadComplete",
    value: function () {
      var _handlePdfLoadComplete = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
        return _regeneratorRuntime().wrap(function _callee4$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return this.getOutline(e);
            case 2:
              this.loading = false;
              this.pdfLoading = false;
              this.requestUpdateVoid();
            case 5:
            case "end":
              return _context24.stop();
          }
        }, _callee4, this);
      }));
      function handlePdfLoadComplete(_x2) {
        return _handlePdfLoadComplete.apply(this, arguments);
      }
      return handlePdfLoadComplete;
    }()
  }, {
    key: "navigateToBookmark",
    value: function navigateToBookmark(e) {
      var _this$shadowRoot11;
      var renderer = (_this$shadowRoot11 = this.shadowRoot) === null || _this$shadowRoot11 === void 0 ? void 0 : _this$shadowRoot11.querySelector('#pdfRenderer');
      if (renderer !== null && renderer !== void 0 && renderer.bookmark) {
        renderer.bookmark = e.detail;
      }
    }
  }, {
    key: "closeOutline",
    value: function closeOutline() {
      this.showOutline = false;
      this.requestUpdateVoid();
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this$shadowRoot12;
      this.documentItem = null;
      this.zoom = this.initialZoom || 1;
      this.showPassword = false;
      this.password = '';
      ((_this$shadowRoot12 = this.shadowRoot) === null || _this$shadowRoot12 === void 0 ? void 0 : _this$shadowRoot12.host).style.setProperty('--zoom', this.zoom);
      this.hideTooltips();
      this.renderingError = false;
      this.currentPage = 1;
      this.totalPages = 1;
    }
  }, {
    key: "setDocument",
    value: function () {
      var _setDocument = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _context25, _currentDoc$document, _currentDoc$document$;
        var currentDoc, mimeType, url, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              currentDoc = this.previewItems[this.currentIndex];
              console.log('current doc', currentDoc);
              this.documentName = currentDoc.name;
              mimeType = currentDoc.mimeType;
              url = currentDoc.url;
              url = currentDoc.token ? (0, _concat.default)(_context25 = "".concat(url, "?Token=")).call(_context25, currentDoc.token) : url;
              data = {
                url: url,
                mimeType: mimeType,
                context: this
              };
              if (!(mimeType === 'application/pdf' || mimeType === 'pdf')) {
                _context26.next = 11;
                break;
              }
              _context26.t0 = url;
              _context26.next = 14;
              break;
            case 11:
              _context26.next = 13;
              return (0, _document.getDocument)(data);
            case 13:
              _context26.t0 = _context26.sent;
            case 14:
              this.documentItem = _context26.t0;
              if (currentDoc !== null && currentDoc !== void 0 && (_currentDoc$document = currentDoc.document) !== null && _currentDoc$document !== void 0 && (_currentDoc$document$ = _currentDoc$document.legacyItem) !== null && _currentDoc$document$ !== void 0 && _currentDoc$document$.versionId) {
                this.documentVerId = currentDoc.document.legacyItem.versionId;
              }
              if (this.documentItem) {
                this.renderingError = false;
                if (_htmlWhitelist.default.supportedTypesIncludes(mimeType)) {
                  this.setPages();
                  this.setInitialZoom();
                }
              } else {
                this.renderingError = true;
              }
            case 17:
            case "end":
              return _context26.stop();
          }
        }, _callee5, this);
      }));
      function setDocument() {
        return _setDocument.apply(this, arguments);
      }
      return setDocument;
    }()
  }, {
    key: "prevDoc",
    value: function () {
      var _prevDoc = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              this.loading = true;
              this.reset();
              this.currentIndex--;
              _context27.next = 5;
              return this.setDocument();
            case 5:
              this.loading = false;
              this.pdfLoading = this.isPdf();
              (0, _emitEvents.emit)(this, 'documentNav', this.documents[this.currentIndex]);
              this.requestUpdateVoid();
            case 9:
            case "end":
              return _context27.stop();
          }
        }, _callee6, this);
      }));
      function prevDoc() {
        return _prevDoc.apply(this, arguments);
      }
      return prevDoc;
    }()
  }, {
    key: "nextDoc",
    value: function () {
      var _nextDoc = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              this.loading = true;
              this.reset();
              this.currentIndex++;
              _context28.next = 5;
              return this.setDocument();
            case 5:
              this.loading = false;
              this.pdfLoading = this.isPdf();
              (0, _emitEvents.emit)(this, 'documentNav', this.documents[this.currentIndex]);
              this.requestUpdateVoid();
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee7, this);
      }));
      function nextDoc() {
        return _nextDoc.apply(this, arguments);
      }
      return nextDoc;
    }()
  }, {
    key: "prevPage",
    value: function prevPage() {
      this.currentPage--;
      this.jumpScroll = true;
      this.requestUpdateVoid();
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      this.currentPage++;
      this.jumpScroll = true;
      this.requestUpdateVoid();
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      var _this$shadowRoot13;
      this.zoom = Math.round((this.zoom + 0.1) * 100) / 100;
      ((_this$shadowRoot13 = this.shadowRoot) === null || _this$shadowRoot13 === void 0 ? void 0 : _this$shadowRoot13.host).style.setProperty('--zoom', this.zoom);
      this.handlePreviewContainerPositioning();
      this.requestUpdateVoid();
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var _this$shadowRoot14;
      this.zoom = Math.round((this.zoom - 0.1) * 100) / 100;
      ((_this$shadowRoot14 = this.shadowRoot) === null || _this$shadowRoot14 === void 0 ? void 0 : _this$shadowRoot14.host).style.setProperty('--zoom', this.zoom);
      this.handlePreviewContainerPositioning();
      this.requestUpdateVoid();
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation(dir) {
      if (dir === 'left') {
        return this.html(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n        <button class=\"document-select-nav-left\"\n                title=\"", "\"\n                data-toggle=\"tooltip-right\"\n                @click=\"", "\"\n                .disabled=\"", "\">\n          <span class=\"bento-icon-chevron-left\"></span>\n        </button>"])), (0, _i18n.translate)('preview.previousDocument'), this.prevDoc, this.currentIndex === 0 || this.loading || this.actionLoading);
      }
      return this.html(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n        <button class=\"document-select-nav-right\"\n                title=\"", "\"\n                data-toggle=\"tooltip-left\"\n                @click=\"", "\"\n                .disabled=\"", "\">\n          <span class=\"bento-icon-chevron-right\"></span>\n        </button>"])), (0, _i18n.translate)('preview.nextDocument'), this.nextDoc, this.currentIndex === (this.previewItems ? this.previewItems.length - 1 : 0) || this.loading || this.actionLoading);
    }
  }, {
    key: "renderPdfRenderer",
    value: function renderPdfRenderer() {
      return this.html(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      <div class=\"pdf-renderer-wrapper\">\n        <pdf-renderer id=\"pdfRenderer\"\n                      .documentVerId=\"", "\"\n                      .pdf=\"", "\"\n                      .minZoom=\".2\"\n                      .maxZoom=\"5\"\n                      .zoomScale=\".1\"\n                      .initialZoom=\"", "\"\n                      .rotate=\"", "\"\n                      .password=\"", "\"\n                      @pdf-load-complete=\"", "\"\n                      @error=\"", "\">\n        </pdf-renderer>\n      </div>"])), this.documentVerId, this.documentItem, this.zoom, this.rotate, this.password, this.handlePdfLoadComplete, this.handlePdfRendererError);
    }
  }, {
    key: "renderHTML",
    value: function renderHTML() {
      return this.html(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      <div id=\"htmlPreviewWrapper\" tabindex=\"-1\">\n        <div id=\"htmlPreviewContainer\"></div>\n      </div>"])));
    }
  }, {
    key: "renderPreviewUnavailableDownloadButton",
    value: function renderPreviewUnavailableDownloadButton() {
      var _this6 = this;
      return this.html(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      <button @click=\"", "\"\n              class=\"btn btn-outline-primary download\">\n        <span class=\"bento-icon-download\"></span> <span>", "</span>\n      </button>"])), function () {
        void (0, _actions.download)(_this6);
      }, (0, _i18n.translate)('button.download'));
    }
  }, {
    key: "renderPreviewUnavailable",
    value: function renderPreviewUnavailable() {
      return this.html(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      <div class=\"preview-not-available\">\n        <span>", "</span>\n        ", "\n      </div>"])), (0, _i18n.translate)('preview.notAvailable'), this.hideDownload ? null : this.renderPreviewUnavailableDownloadButton());
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return this.html(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      <span class=\"document-preview-loading\">", "<span>.</span><span>.</span><span>.</span></span>"])), (0, _i18n.translate)('loading'));
    }
  }, {
    key: "renderNextPageButton",
    value: function renderNextPageButton() {
      return this.html(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      <button @click=\"", "\"\n              class=\"page-button\"\n              .disabled=\"", "\">\n        <span class=\"bento-icon-chevron-down\"></span>\n      </button>"])), this.nextPage, this.currentPage === this.totalPages);
    }
  }, {
    key: "renderPrevPageButton",
    value: function renderPrevPageButton() {
      return this.html(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      <button @click=\"", "\"\n              class=\"page-button\"\n              .disabled=\"", "\">\n        <span class=\"bento-icon-chevron-up\"></span>\n      </button>"])), this.prevPage, this.currentPage === 1);
    }
  }, {
    key: "renderPageZoomControls",
    value: function renderPageZoomControls() {
      return this.html(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      <div class=\"page-number-zoom-options\">\n        ", "\n        <span class=\"", "\">\n          ", " ", " / ", "\n        </span>\n        ", "\n        <div class=\"vertical-separator\"></div>\n        <button @click=\"", "\"\n                class=\"zoom-button\"\n                .disabled=\"", "\">\n          <span class=\"bento-icon-zoomout\"></span>\n        </button>\n        <span>", "%</span>\n        <button @click=\"", "\"\n                class=\"zoom-button\"\n                .disabled=\"", "\">\n          <span class=\"bento-icon-zoomin\"></span>\n        </button>\n      </div>"])), this.totalPages > 1 ? this.renderPrevPageButton() : null, this.totalPages === 1 ? 'add-margin' : '', (0, _i18n.translate)('page'), this.currentPage, this.totalPages, this.totalPages > 1 ? this.renderNextPageButton() : null, this.zoomOut, this.zoom === 0.2, (this.zoom * 100).toFixed(0), this.zoomIn, this.zoom === 5);
    }
  }, {
    key: "setPreview",
    value: function setPreview() {
      var _this7 = this;
      if (!this.loading && Boolean(this.documentItem)) {
        (0, _setTimeout2.default)(function () {
          var _this7$shadowRoot;
          var previewContainer = (_this7$shadowRoot = _this7.shadowRoot) === null || _this7$shadowRoot === void 0 ? void 0 : _this7$shadowRoot.querySelector('#htmlPreviewContainer');
          if (previewContainer) {
            var _this7$shadowRoot2, _this7$shadowRoot2$qu, _this7$shadowRoot3, _this7$shadowRoot3$qu, _context29, _this7$shadowRoot5, _this7$shadowRoot5$qu;
            (_this7$shadowRoot2 = _this7.shadowRoot) === null || _this7$shadowRoot2 === void 0 ? void 0 : (_this7$shadowRoot2$qu = _this7$shadowRoot2.querySelector('#htmlPreviewWrapper')) === null || _this7$shadowRoot2$qu === void 0 ? void 0 : _this7$shadowRoot2$qu.removeEventListener('scroll', _this7.setCurrentPage);
            (_this7$shadowRoot3 = _this7.shadowRoot) === null || _this7$shadowRoot3 === void 0 ? void 0 : (_this7$shadowRoot3$qu = _this7$shadowRoot3.querySelector('#htmlPreviewWrapper')) === null || _this7$shadowRoot3$qu === void 0 ? void 0 : _this7$shadowRoot3$qu.focus();
            previewContainer.innerHTML = (0, _indexOf.default)(_context29 = _this7.previewItems[_this7.currentIndex].mimeType).call(_context29, 'message/') === 0 || _this7.previewItems[_this7.currentIndex].mimeType === 'eml' || _this7.previewItems[_this7.currentIndex].mimeType === 'mht' ? "<div class=\"message-preview-wrapper\">".concat(_this7.documentItem, "</div>") : _this7.documentItem;
            if (_this7.jumpScroll) {
              var _this7$shadowRoot4;
              var mimeToSearch = _this7.previewItems[_this7.currentIndex].mimeType;
              (_this7$shadowRoot4 = _this7.shadowRoot) === null || _this7$shadowRoot4 === void 0 ? void 0 : _this7$shadowRoot4.querySelectorAll(_htmlWhitelist.default.supportedTypesFindQuerySelector(mimeToSearch))[_this7.currentPage - 1].scrollIntoView();
            }
            (_this7$shadowRoot5 = _this7.shadowRoot) === null || _this7$shadowRoot5 === void 0 ? void 0 : (_this7$shadowRoot5$qu = _this7$shadowRoot5.querySelector('#htmlPreviewWrapper')) === null || _this7$shadowRoot5$qu === void 0 ? void 0 : _this7$shadowRoot5$qu.addEventListener('scroll', _this7.setCurrentPage);
          }
        }, 50);
      }
    }
  }, {
    key: "renderOutline",
    value: function renderOutline() {
      return this.html(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n      <pdf-outline class=\"", "\"\n                   .outline=\"", "\"\n                   @outline-item-clicked=\"", "\">\n      </pdf-outline>"])), this.hideClose ? 'no-close' : '', this.outline, this.navigateToBookmark);
    }
  }, {
    key: "renderInvalidPassword",
    value: function renderInvalidPassword() {
      return this.html(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n      <div class=\"errorMessage\"><span class=\"bento-icon-warning\"></span>Invalid password.</div>"])));
    }
  }, {
    key: "renderPassword",
    value: function renderPassword() {
      var _this8 = this;
      (0, _setTimeout2.default)(function () {
        var _this8$shadowRoot, _this8$shadowRoot$que, _this8$shadowRoot$que2;
        (_this8$shadowRoot = _this8.shadowRoot) === null || _this8$shadowRoot === void 0 ? void 0 : (_this8$shadowRoot$que = _this8$shadowRoot.querySelector('#passwordPrompt')) === null || _this8$shadowRoot$que === void 0 ? void 0 : (_this8$shadowRoot$que2 = _this8$shadowRoot$que.querySelector('input')) === null || _this8$shadowRoot$que2 === void 0 ? void 0 : _this8$shadowRoot$que2.focus();
      }, 50);
      return this.html(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      <div id=\"passwordPrompt\">\n        <h1>", "</h1>\n        <p>", "</p>\n        <input type=\"password\" @keyup=\"", "\"/>\n        ", "\n        <button type=\"submit\"\n                class=\"btn btn-outline-primary\"\n                @click=\"", "\">", "</button>\n      </div>"])), (0, _i18n.translate)('preview.passwordRequired'), (0, _i18n.translate)('preview.passwordDesc'), this.handlePasswordKey, this.invalidPassword ? this.renderInvalidPassword() : null, this.handlePassword, (0, _i18n.translate)('button.submit'));
    }
  }, {
    key: "renderPage",
    value: function renderPage() {
      if (Boolean(this.previewItems) && Boolean(this.previewItems[this.currentIndex]) && _htmlWhitelist.default.supportedTypesIncludes(this.previewItems[this.currentIndex].mimeType)) {
        this.setPreview();
      }
      return this.html(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n      ", "\n      ", "\n      ", "\n      ", "\n      ", "\n      ", "\n      ", "\n      ", ""])), (0, _header.renderHeader)(this), this.previewItems.length > 1 ? this.renderNavigation('left') : null, this.loading || this.pdfLoading ? this.renderLoading() : null, this.isPdf() && !this.loading && !this.showPassword ? this.renderingError ? this.renderPreviewUnavailable() : this.documentItem ? this.renderPdfRenderer() : null : null, this.showPassword ? this.renderPassword() : null, !this.usePDF && Boolean(this.previewItems) && Boolean(this.previewItems[this.currentIndex]) && _htmlWhitelist.default.supportedTypesIncludes(this.previewItems[this.currentIndex].mimeType) ? !this.loading && !this.renderingError ? this.renderHTML() : this.renderingError ? this.renderPreviewUnavailable() : null : null, this.previewItems.length > 1 ? this.renderNavigation('right') : null, this.renderingError || !(Boolean(this.previewItems) && Boolean(this.previewItems[this.currentIndex]) && _htmlWhitelist.default.supportedTypesIncludes(this.previewItems[this.currentIndex].mimeType)) ? null : this.renderPageZoomControls());
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n      ", "\n      ", ""])), this.renderPage(), this.showOutline ? this.renderOutline() : null);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'file-preview';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        currentIndex: {
          type: Number,
          attribute: true,
          reflect: false
        },
        customHeaderButtons: {
          type: Object,
          attribute: false,
          reflect: false
        },
        documents: {
          type: Object,
          attribute: false,
          reflect: false
        },
        documentName: {
          type: String,
          attribute: true,
          reflect: false
        },
        downloadUri: {
          type: String,
          attribute: true,
          reflect: false
        },
        emitHeaderButtonClicks: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        helpItems: {
          type: Object,
          attribute: false,
          reflect: false
        },
        hideDocumentName: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        hideBookmarks: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        hideClose: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        hideDelete: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        hideDownload: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        hideHelp: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        hidePrint: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        lang: {
          type: String,
          attribute: true,
          reflect: false
        },
        themeColor: {
          type: String,
          attribute: true,
          reflect: false
        },
        usePDF: {
          type: Boolean,
          attribute: false,
          reflect: false
        },
        loading: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        showIndex: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        bookmark: {
          type: String,
          attribute: true,
          reflect: false
        },
        rotate: {
          type: Number,
          attribute: true,
          reflect: true
        },
        initialZoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        token: {
          type: String,
          attribute: true,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return _styles.mainStyling;
    }
  }]);
  return FilePreview;
}(_element.BlueElement);
exports.FilePreview = FilePreview;
var registerFilePreview = function registerFilePreview() {
  (0, _pdfRenderer.registerPDFRenderer)();
  (0, _outline2.registerOutline)();
  (0, _element.register)(FilePreview);
};
exports.registerFilePreview = registerFilePreview;
function openPreview(data, errorCallback, headerButtonClickCallback, closeCallback) {
  (0, _element.register)(FilePreview);
  var previewEl = document.createElement('file-preview');
  previewEl.bookmark = data.bookmark;
  previewEl.customHeaderButtons = data.customHeaderButtons;
  previewEl.helpItems = data.helpItems;
  previewEl.currentIndex = data.currentIndex;
  previewEl.documents = data.documents;
  previewEl.downloadUri = data.downloadUri;
  previewEl.emitHeaderButtonClicks = data.emitHeaderButtonClicks;
  previewEl.hideDocumentName = data.hideDocumentName;
  previewEl.hideBookmarks = data.hideBookmarks;
  previewEl.hideClose = data.hideClose;
  previewEl.hideDelete = data.hideDelete;
  previewEl.hideDownload = data.hideDownload;
  previewEl.hidePrint = data.hidePrint;
  previewEl.lang = data.lang;
  previewEl.themeColor = data.themeColor;
  previewEl.usePDF = data.usePDF;
  previewEl.initialZoom = data.initialZoom;
  previewEl.style.zIndex = data.zIndex;
  previewEl.token = data.token;
  var container = data.parentEl || document.body;
  var close = function close() {
    var remove = closeCallback ? closeCallback() : true;
    if (remove !== false) {
      container.removeChild(previewEl);
      container.style.overflow = '';
      container.style.transform = '';
    }
  };
  previewEl.addEventListener('closePreview', close);
  previewEl.addEventListener('error', errorCallback);
  previewEl.addEventListener('headerButtonClick', headerButtonClickCallback);
  var append = container.append || container.appendChild;
  append.call(container, previewEl);
  container.style.overflow = 'hidden';
  if (data.parentEl) {
    container.style.transform = 'translateZ(0)';
  }
  return close;
}
